<template>
  <div class="langSwitcher" v-if="ready">
    <dropdown ref="dropdown" class="langSwitcher__container">
      <div slot="link"
           class="langSwitcher__current btn"
           id="langSwitcher"
      >
        <span v-if="getLangSwitcher.current.icon"
              class="langSwitcher__currentIcon"
        >
          <i
            class="far"
            :class="getLangSwitcher.current.icon"
          ></i>
        </span>
        <span v-if="getLangSwitcher.current.flag"
              class="langSwitcher__itemFlag mr-2"
              :style="getFlag(current)"
        ></span>
        <span v-if="getLangSwitcher.current.label"
              class="langSwitcher__itemLabel"
        >
          {{ $t((getLangSwitcher.current.label_prefix || '') + current) }}
        </span>
        <i class="fas fa-caret-down"></i>
      </div>
      <div slot="content"
           class="surface"
      >
        <div v-for="locale in langLabels"
             :key="locale"
             class="inputRadio --sm"
             @click="change(locale)"
        >
          <div class="inputRadio__container">
            <input class="inputRadio__input"
                   type="radio"
                   :id="`lang-${locale}`"
                   name="language"
                   :checked="current === locale"
            >
            <span class="inputRadio__checkmark"></span>
            <label :for="`lang-${locale}`"
                   class="inputRadio__label"
                   @click.stop
            >
              <span v-if="getLangSwitcher.languages.flag"
                    class="langSwitcher__itemFlag"
                    :style="getFlag(locale)"
              ></span>
              <span v-if="getLangSwitcher.languages.label"
                    class="langSwitcher__itemLabel"
              >
                {{ $t((getLangSwitcher.languages.label_prefix || '') + locale) }}
              </span>
            </label>
          </div>
        </div>
      </div>
    </dropdown>
  </div>
</template>

<script>
import axios from "axios";
import { setLanguageAsync } from 'core/plugins/I18n'
import dropdown from 'core-lib/components/Dropdown'
import { Validator } from 'vee-validate'
import { mapGetters } from 'vuex'

export default {
  name: 'LangSwitcher',
  inject: ['$validator'],
  components: {
    dropdown
  },
  data () {
    return {
      ready : false
    }
  },
  computed: {
    ...mapGetters(['getLangSwitcher', 'getLanguage']),
    languages: function () {
      return this.getLangSwitcher.languages.items
    },
    langLabels: function () {
      return this.languages.map(x => { return x.lang })
    },
    showFlags: function () {
      return this.getLangSwitcher.flags
    },
    current: function () {
      return this.$i18n.locale
    }
  },
  methods: {
    change: async function (lang) {
      this.$refs.dropdown.toggleDropdown()
      this.$store.commit('setLoading', true)
      await this.getTranslations(lang)
      this.$i18n.locale = lang
      this.$store.commit('setLanguage', lang)
      this.$validator.locale = lang
      this.$store.commit('setLoading', false)
    },
    getTranslations: async function (lang) {
      let langExceptions = {
        'pt': 'pt_PT'
      }
      await setLanguageAsync(this, lang)
      try {
        // lo seteo de nuevo porq setLanguageAsync lo puede cambiar
        lang = this.getLanguage
        Validator.localize(lang, require('vee-validate/dist/locale/' + (langExceptions[lang] ? langExceptions[lang] : lang)))
      } catch (error) {
        console.error(error)
      }
    },
    initLanguages: async function () {
      await this.getTranslations(this.$i18n.locale)
      this.$emit('readyLangSwitcher')
      this.$store.commit('setLoading', false)
    },
    getFlag: function (lang) {
      const langObj = this.languages.find(x => x.lang === lang)
      let imageUrl = langObj.external_image
      if (!imageUrl) {
        try {
          imageUrl = require(`../../assets/img/flags/${langObj.image || lang}.svg`)
        } catch (e) {
          console.error('not exist flag', lang)
          imageUrl = require(`../../assets/img/flags/en.svg`)
        }
      }
      return {
        'background-image': `url('${imageUrl}')`
      }
    }
  },
  mounted () {
    if (this.langLabels.includes(this.$store.getters.getLanguage)){
      document.querySelector('html').translate = false
    }
  },
  async created () {
    this.$store.commit('setLoading', true)
    this.$store.commit('clearAvailableLanguages')
    await this.initLanguages()
    this.ready = true
  },
}
</script>

<style scoped lang="sass">
.langSwitcher
  display: flex
  margin-right: .5rem
  &__current
    min-height: 2rem
    padding: 0 .5rem
    display: flex
    align-items: center
    background-color: var(--color-nav)
    color: var(--color-onNav)
    border-color: var(--color-onNav)
    &Icon
      font-size: var(--font-size-md)
      margin-right: .5rem
    i[class*='caret-']
      opacity: .4
      margin-left: .5rem
  &__container
    position: relative
    display: flex
    align-items: center
  &__item
    &Flag
      height: 1.25rem
      width: 1.25rem
      background-size: cover
      border-radius: 50%
      display: flex
    &Label
      font-size: var(--font-size-sm)
  .surface
    position: absolute
    right: 0
    top: 2.2rem
    padding: .5rem .25rem
  .inputRadio
    margin: 0
    &__label
      display: flex
      align-items: center
      margin: 0
      cursor: pointer
      span
        margin-right: 0.5rem
        &:last-of-type
          margin-right: 0
    &__checkmark
      height: 1rem
      width: 1rem
</style>
